import {
  mdiAccountEditOutline,
  mdiAccountCheckOutline,
  mdiAccountGroupOutline,
  mdiAccountKeyOutline,
  mdiAccountSupervisorOutline,
  mdiAccountTieOutline,
  mdiAccountTieWoman,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowUp,
  mdiBriefcaseOutline,
  mdiCalendarClock,
  mdiChartBoxOutline,
  mdiChartBubble,
  mdiChartLine,
  mdiChartTimelineVariant,
  mdiCheckCircle,
  mdiCheckboxMarkedCircleOutline,
  mdiChevronDown,
  mdiClose,
  mdiCloudOutline,
  mdiCogOutline,
  mdiCogs,
  mdiConnection,
  mdiContentSaveOutline,
  mdiDatabaseLock,
  mdiDomain,
  mdiEarth,
  mdiEmailOutline,
  mdiFileDocumentMultipleOutline,
  mdiFolderImage,
  mdiFormTextbox,
  mdiFormatQuoteOpen,
  mdiHome,
  mdiInformationOutline,
  mdiLightbulbOnOutline,
  mdiLinkVariant,
  mdiMagnify,
  mdiMenu,
  mdiPhone,
  mdiPostOutline,
  mdiRocketLaunchOutline,
  mdiShapeOutline,
  mdiShieldAccountOutline,
  mdiShieldCheck,
  mdiSpeedometer,
  mdiTimerSand,
  mdiTransitConnectionVariant,
  mdiTrashCanOutline,
  mdiVectorPolyline,
  mdiViewDashboardOutline,
  mdiWeb,
} from '@mdi/js'
import { h } from 'vue'
import { aliases as mdiAliases, mdi } from 'vuetify/iconsets/mdi-svg'

const customMdiPaths: Record<string, string> = {
  'mdi-account-edit-outline': mdiAccountEditOutline,
  'mdi-account-check-outline': mdiAccountCheckOutline,
  'mdi-account-group-outline': mdiAccountGroupOutline,
  'mdi-account-key-outline': mdiAccountKeyOutline,
  'mdi-account-supervisor-outline': mdiAccountSupervisorOutline,
  'mdi-account-tie-outline': mdiAccountTieOutline,
  'mdi-account-tie-woman-outline': mdiAccountTieWoman,
  'mdi-arrow-left': mdiArrowLeft,
  'mdi-arrow-right': mdiArrowRight,
  'mdi-arrow-up': mdiArrowUp,
  'mdi-briefcase-outline': mdiBriefcaseOutline,
  'mdi-calendar-clock': mdiCalendarClock,
  'mdi-chart-box-outline': mdiChartBoxOutline,
  'mdi-chart-bubble': mdiChartBubble,
  'mdi-chart-line': mdiChartLine,
  'mdi-chart-timeline-variant': mdiChartTimelineVariant,
  'mdi-check-circle': mdiCheckCircle,
  'mdi-checkbox-marked-circle-outline': mdiCheckboxMarkedCircleOutline,
  'mdi-chevron-down': mdiChevronDown,
  'mdi-close': mdiClose,
  'mdi-cloud-outline': mdiCloudOutline,
  'mdi-cog-outline': mdiCogOutline,
  'mdi-cogs': mdiCogs,
  'mdi-connection': mdiConnection,
  'mdi-content-save-outline': mdiContentSaveOutline,
  'mdi-database-lock': mdiDatabaseLock,
  'mdi-domain': mdiDomain,
  'mdi-earth': mdiEarth,
  'mdi-email-outline': mdiEmailOutline,
  'mdi-file-document-multiple-outline': mdiFileDocumentMultipleOutline,
  'mdi-folder-image': mdiFolderImage,
  'mdi-form-textbox': mdiFormTextbox,
  'mdi-format-quote-open': mdiFormatQuoteOpen,
  'mdi-home': mdiHome,
  'mdi-information-outline': mdiInformationOutline,
  'mdi-lightbulb-on-outline': mdiLightbulbOnOutline,
  'mdi-link-variant': mdiLinkVariant,
  'mdi-magnify': mdiMagnify,
  'mdi-menu': mdiMenu,
  'mdi-phone': mdiPhone,
  'mdi-post-outline': mdiPostOutline,
  'mdi-rocket-launch-outline': mdiRocketLaunchOutline,
  'mdi-shape-outline': mdiShapeOutline,
  'mdi-shield-account-outline': mdiShieldAccountOutline,
  'mdi-shield-check': mdiShieldCheck,
  'mdi-speedometer': mdiSpeedometer,
  'mdi-timer-sand': mdiTimerSand,
  'mdi-transit-connection-variant': mdiTransitConnectionVariant,
  'mdi-trash-can-outline': mdiTrashCanOutline,
  'mdi-vector-polyline': mdiVectorPolyline,
  'mdi-view-dashboard-outline': mdiViewDashboardOutline,
  'mdi-web': mdiWeb,
}

function resolveMdiPath(icon: unknown): unknown {
  if (typeof icon !== 'string') return icon

  if (icon.startsWith('svg:')) {
    return icon.slice(4)
  }

  if (!icon.startsWith('mdi-')) {
    return icon
  }

  return customMdiPaths[icon] ?? icon
}

export const mdiSvgAliases = {
  ...mdiAliases,
}

export const mdiSvgSet: any = {
  component: (props: { icon?: unknown; [key: string]: unknown }) => h(mdi.component as any, {
    ...props,
    icon: resolveMdiPath(props.icon),
  }),
}
